"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monte-san-pietro": {
    "269e0637": [{
      "hkey": "ffdd5e6f",
      "slug": "calderino",
      "name": "Calderino",
      "primary": true,
      "skipSearch": false
    }],
    "calderino-amola": [{
      "hkey": "ffdd5e6f",
      "slug": "calderino",
      "name": "Calderino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "aebbfb43": [{
      "hkey": "3a52a8f7",
      "slug": "monte-san-pietro",
      "name": "Monte San Pietro",
      "primary": true,
      "skipSearch": false
    }],
    "gavignano": [{
      "hkey": "3a52a8f7",
      "slug": "monte-san-pietro",
      "name": "Monte San Pietro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0f243ef6": [{
      "hkey": "3e3c8b6e",
      "slug": "loghetto",
      "name": "Loghetto",
      "primary": true,
      "skipSearch": false
    }],
    "loghetto-monte-san-pietro": [{
      "hkey": "3e3c8b6e",
      "slug": "loghetto",
      "name": "Loghetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "305ded97": [{
      "hkey": "98a803bc",
      "slug": "mongiorgio",
      "name": "Mongiorgio",
      "primary": true,
      "skipSearch": false
    }],
    "monte-san-giovanni-mongiorgio": [{
      "hkey": "98a803bc",
      "slug": "mongiorgio",
      "name": "Mongiorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1338ca34": [{
      "hkey": "3a52a8f7",
      "slug": "monte-san-pietro",
      "name": "Monte San Pietro",
      "primary": true,
      "skipSearch": false
    }],
    "montepastore-ronca": [{
      "hkey": "3a52a8f7",
      "slug": "monte-san-pietro",
      "name": "Monte San Pietro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3113e74e": [{
      "hkey": "3a52a8f7",
      "slug": "monte-san-pietro",
      "name": "Monte San Pietro",
      "primary": true,
      "skipSearch": false
    }],
    "montesevero": [{
      "hkey": "3a52a8f7",
      "slug": "monte-san-pietro",
      "name": "Monte San Pietro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4af8e1f6": [{
      "hkey": "3a52a8f7",
      "slug": "monte-san-pietro",
      "name": "Monte San Pietro",
      "primary": true,
      "skipSearch": false
    }],
    "ozzano-dell-amola": [{
      "hkey": "3a52a8f7",
      "slug": "monte-san-pietro",
      "name": "Monte San Pietro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2c3ac4ad": [{
      "hkey": "3a52a8f7",
      "slug": "monte-san-pietro",
      "name": "Monte San Pietro",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino-pradalbino": [{
      "hkey": "3a52a8f7",
      "slug": "monte-san-pietro",
      "name": "Monte San Pietro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;